import React, {Component} from 'react';

import { Box, type Theme } from '@mui/material';

import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar'; 
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Help from '@mui/icons-material/Help';
import {CenterGrid} from '../../components/layout';

const s:any ={
  loginbox: {
    //width: 450
    margin:'50px auto',
    display: 'inline-block'
  },
  loginform: {
    p: 1,
  },
  titlebar: {
    color: 'white',
    textAlign: 'center',
    flex:1
  },
  formControl: {
    m: 1,
  },
  input: {
    m: 1,
  },
  actionbox: {
    display: 'flex',
    justifyContent: 'center'
  },
  action: {
    margin: 'auto 5px',
  },
  button: {
    m: 1,
  },
  leftIcon: {
    mr: 1,
  },
  textField: {
    ml: 1,
    mr: 1,
    //width: 200,
  },
  menu: {
    //width: 200,
  },
  hide: {
    display:'node'
  },
  show: {
    display:'inline-block'
  },
  logo: (theme:Theme)=> ({
    cursor: 'pointer',
    fontSize: 22,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightLight,
    backgroundImage: 'url(lib/img/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
    paddingLeft: 5,
    paddingRight: 5,
    height: 20,
    width:25,
    [theme.breakpoints.down('sm')]:{
      display:'none',
    },
  })
  
};

class About extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      loading: false,
      count: 0,
      open: false,
      sbopen: false,
      sbmesg: '',
      username: '',
      password:'',
      showPassword: false,
      context: props.context,
      serviceid: 1,
      remember: false
    };
  }

  onHelp = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      //this.props.closeDrawer();
    });
  };

  onSupport = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'support';
    this.props.handleSetContent(null,page).then( () => {
      //this.props.closeDrawer();
    });
  };

  render() {
    const {service,code,showNotification,setPage,setHome,classes, theme} = this.props;
    //const vertical = 'top', horizontal = 'center';
    const logosrc = '/api/logo/icon.png';

    return (
      <CenterGrid>
        <Paper elevation={3} square={false}>
        <AppBar position="static">
          <Toolbar>
            <Box sx={{...s.logo}} style={{backgroundImage: `url(${logosrc})`}}/>
            <Typography variant="h3" sx={{...s.titlebar}}>
              About...
            </Typography>
          </Toolbar>
        </AppBar>
          <Box>
          <Box component='form' id="aboutform" sx={{...s.loginform}}>
            
            <Box>
              <Typography>
                SCSMS 1.0
              </Typography>
            </Box>
            <Box>
              <Typography>
                Sales and Customer Management System
              </Typography>  
            </Box>
            <Box>
              <Typography>
                Customers, quotations, orders, invoicing, payments, stock and approvals
              </Typography> 
            </Box>
            <br/>
            <Box>
              <Typography>
                &copy; K-Frontiers Limited. Powered by Iridis Labs
              </Typography> 
            </Box>
          </Box>
          </Box>
        </Paper>
        <Box>
          <Button sx={{...s.button}} onClick={this.onSupport}><PersonAdd sx={{...s.leftIcon}}/> Contact us</Button>
          <Button sx={{...s.button}} onClick={this.onHelp}><Help sx={{...s.leftIcon}}/>More info?</Button>
        </Box>
        <Box>
          
        </Box>
      </CenterGrid>
    );
  }

  
}

export default About;
